import { logError } from "./serverlog";

// In case of HTTP response outside of 200-299 range
function checkForHTTPError(
  response: Response,
  errorRedirectUrl = "/registrering/bedrift?logout=1",
): Response {
  if (response.ok || response.status === 409) {
    return response;
  } else {
    const error = new Error(`${response.status}`);
    if (response.status === 401 || response.status === 403) {
      window.location.href = errorRedirectUrl;
      console.error(error);
    } else {
      console.error(error);
    }
    throw error;
  }
}

export async function get(
  uri: string,
  errorRedirectUrl?: string,
): Promise<Response> {
  try {
    const response = await fetch(uri, { credentials: "same-origin" });
    return checkForHTTPError(response, errorRedirectUrl);
  } catch (e) {
    logError(e as Error);
    throw e;
  }
}

export async function getJSON<T>(
  uri: string,
  errorRedirectUrl?: string,
): Promise<T> {
  try {
    return (await (await get(uri, errorRedirectUrl)).json()) as T;
  } catch (e) {
    logError(e as Error);
    throw e;
  }
}

export async function request(
  method: "GET" | "PUT" | "POST" | "PATCH" | "DELETE",
  csrfToken: string | undefined,
  uri: string,
  body?: Record<string, unknown>,
  errorRedirectUrl?: string,
  headers?: Record<string, string>,
): Promise<Response> {
  try {
    const response = await fetch(uri, {
      method: method,
      credentials: "same-origin",
      body: body ? JSON.stringify(body) : undefined,
      headers: {
        Accept: "application/vnd.digipost-v2+json",
        "Content-Type": "application/vnd.digipost-v2+json",
        "X-CSRF-TOKEN": csrfToken || "",
        ...headers,
      },
    });
    return checkForHTTPError(response, errorRedirectUrl);
  } catch (e) {
    logError(e as Error);
    throw e;
  }
}

export function post(
  uri: string,
  body?: Record<string, unknown>,
  csrfToken?: string,
  errorRedirectUrl?: string,
): Promise<Response> {
  return request("POST", csrfToken, uri, body, errorRedirectUrl);
}

export function put(
  uri: string,
  body?: Record<string, unknown>,
  csrfToken?: string,
): Promise<Response> {
  return request("PUT", csrfToken, uri, body);
}

export function remove(
  uri: string,
  csrfToken?: string,
  headers?: Record<string, string>,
): Promise<Response> {
  return request("DELETE", csrfToken, uri, {}, undefined, headers);
}
